var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.869-98.52v-681.393q0-32.74 23.356-56.262 23.355-23.521 55.862-23.521h429.826q32.74 0 56.262 23.521 23.521 23.522 23.521 56.262v681.392L480-224.173 185.869-98.521Zm79.218-120.393L480-309.179l214.913 90.266v-561H265.087v561Zm0-561h429.826-429.826Z"
  })));
}
export default SvgBookmark;